module.exports = __webpack_public_path__ + "static/media/autobookContainer.c93f3847.svg";